/**
 * VideoView — the browser's own video player, with controls, and no
 * autoplay; the file card when the browser can't play the file. The source is
 * the file already downloaded (a `blob:` URL), so `preload` saves no network —
 * it only keeps the browser from decoding ahead before play is pressed.
 */
import { useState, type ReactNode } from 'react';

const VIDEO_PRELOAD = 'metadata';
const VIDEO_CLASS = 'max-h-full max-w-full rounded-md bg-black';

export interface VideoViewProps {
  src: string;
  name: string;
  fallback: ReactNode;
}

export function VideoView({ src, name, fallback }: VideoViewProps) {
  const [unplayable, setUnplayable] = useState(false);

  function handleError(): void {
    setUnplayable(true);
  }

  if (unplayable) return fallback;
  return <video src={src} controls preload={VIDEO_PRELOAD} aria-label={name} className={VIDEO_CLASS} onError={handleError} />;
}
